import React, { useState } from 'react';
import { Card, CardContent, Typography, IconButton, Button, Box, Divider, Dialog, DialogTitle, DialogActions, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ApartmentIcon from '@mui/icons-material/Apartment';
import EuroIcon from '@mui/icons-material/Euro';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NightsStayIcon from '@mui/icons-material/NightsStay';

const valueFields = [
    {
        icon: <EuroIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Electricity Price', valueKey: 'electricity_price',
        format: v => `€${v} / kWh`
    },
    {
        icon: <LocalGasStationIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Gas Price', valueKey: 'gas_price',
        format: v => `€${v} / m³`
    },
    {
        icon: <OilBarrelIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Oil Price', valueKey: 'oil_price',
        format: v => `€${v} / m³`
    },
    {
        icon: <ThermostatIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Indoor Temp', valueKey: 'T_inside_heating',
        format: v => `${v}°C`
    },
    {
        icon: <AccessTimeIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Daily Hours', valueKey: 'daily_hours',
        format: v => v
    },
    {
        icon: <NightsStayIcon color="primary" sx={{ fontSize: 28 }} />, title: 'Nightly Hours', valueKey: 'nightly_hours',
        format: v => v
    },
];

const BuildingCard = ({ building, onDelete, onDetails }) => {
    const [openDialog, setOpenDialog] = useState(false);

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        setOpenDialog(true);
    };

    const handleConfirmDelete = () => {
        setOpenDialog(false);
        onDelete();
    };

    const handleCancelDelete = () => {
        setOpenDialog(false);
    };

    return (
        <Card
            elevation={6}
            sx={{
                position: 'relative',
                height: '100%',
                borderRadius: 4,
                transition: 'box-shadow 0.3s',
                '&:hover': {
                    boxShadow: 12,
                },
                background: 'linear-gradient(135deg, #ffffff 0%, #f5faff 100%)', // even lighter
            }}
        >
            <IconButton
                onClick={handleDeleteClick}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'error.main',
                    zIndex: 2,
                }}
                aria-label="delete"
            >
                <DeleteIcon />
            </IconButton>
            <CardContent sx={{ pb: 7 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <ApartmentIcon sx={{ color: 'primary.main', fontSize: 32, mr: 1 }} />
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                        {building.name}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                    {valueFields.map((field, idx) => (
                        <Grid item xs={12} sm={4} key={field.valueKey} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {field.icon}
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, fontWeight: 500 }}>
                                {field.title}
                            </Typography>
                            <Typography variant="body1" fontWeight="bold" color="text.primary" sx={{ mt: 0.5 }}>
                                {field.format(building[field.valueKey])}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ position: 'relative ', display: 'flex', justifyContent: 'end', gap: 1, mt: 3 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={onDetails}
                        sx={{ borderRadius: 3 }} // add margin top
                    >
                        Details
                    </Button>
                </Box>
            </CardContent>
            <Dialog open={openDialog} onClose={handleCancelDelete}>
                <DialogTitle>Are you sure you want to delete this building?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary" variant="outlined">Cancel</Button>
                    <Button onClick={handleConfirmDelete} color="error" variant="contained">Delete</Button>
                </DialogActions>
            </Dialog>
        </Card >
    );
};

export default BuildingCard;
